import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Concept} from '../models/concept';

export const conceptsActionTypes = {
  LOAD: type('[Concepts] Load'),
  LOAD_SUCCESS: type('[Concepts] Load Success'),
  LOAD_FAIL: type('[Concepts] Load Error')
};

export class LoadConceptsAction implements Action {
  readonly type = conceptsActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}


export class LoadConceptsSuccessAction implements Action {
  readonly type = conceptsActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Concept[]) {}
}

export class LoadConceptsFailAction implements Action {
  readonly type = conceptsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
